import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from '../../api';
import { Status } from "../../common/constants";
import { updateDeviceUrl } from "../../config";
import { RootState } from "../../store";
import { IUpdateDevicePayload, IUpdateDeviceState } from "../../common/types/devicesTypes";

const initialState: IUpdateDeviceState = {
  status: Status.IDLE,
  error: null,
  msg: null,
  deviceId: null,
  orgId: null,
  displayName: null,
  isActive: false,
};

interface IUpdateDeviceResponse {
  message: string
}



export const updateDeviceModal = createAsyncThunk("updateDevice", async (payload: IUpdateDevicePayload, { rejectWithValue }) => {
    try {
      const response = await api.patch(updateDeviceUrl + `?deviceId=${payload.deviceId}`, payload.body);
      const updateDeviceResponse: IUpdateDeviceResponse = response.data;
      return updateDeviceResponse;
    } catch (error) {
      throw rejectWithValue(error);
    }
  }
);

const updateDeviceModalSlice = createSlice({
  name: "updateDevice",
  initialState,
  reducers: {
    showModal: (state: IUpdateDeviceState) => {
      state.isActive = true;
    },
    hideModal: (state: IUpdateDeviceState) => {
      state.isActive = false;
    },
    setStatus: (state: IUpdateDeviceState) => {
      state.status = Status.IDLE;
    },
    setEditDeviceData: (state: IUpdateDeviceState, action) => {
      if(action.payload) {
        state.deviceId = action.payload.deviceId;
        state.orgId = action.payload.orgId;
        state.displayName = action.payload.displayName;
      } else {
        state.orgId = initialState.orgId;
        state.deviceId = initialState.deviceId;
        state.displayName = initialState.displayName;
      }
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateDeviceModal.pending, (state) => {
        state.status = Status.PENDING;
        state.msg = null;
      })
      .addCase(updateDeviceModal.fulfilled, (state, action) => {
        state.msg = action.payload.message;
        state.status = Status.SUCCESS
      })
      .addCase(updateDeviceModal.rejected, (state, action) => {
        const errorPayload = action.payload as { response?: { data?: { error?: { message?: string }, message?: string } } };
        state.msg = errorPayload.response?.data?.error?.message || errorPayload.response?.data?.message || 'Error occurred while updating';
        state.status = Status.FAILED;
      });
  },
});

export const {showModal, hideModal, setEditDeviceData, setStatus } = updateDeviceModalSlice.actions;
export const selector = (state: RootState) => state.updateDeviceApi;

export default updateDeviceModalSlice.reducer;